import { render, staticRenderFns } from "./SubDomain.page.vue?vue&type=template&id=2f6b2f00&"
import script from "./SubDomain.page.vue?vue&type=script&lang=js&"
export * from "./SubDomain.page.vue?vue&type=script&lang=js&"
import style0 from "./SubDomain.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports